import { Box } from '@chakra-ui/react'
import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from 'recharts'
import { useChartTheme } from '../../../hooks/useChartTheme'
import CustomTooltip from './CustomTooltip'
import type { MonthlyTonnagePoint } from '../../../data/mockEstadisticas'

const minerals: { key: keyof Omit<MonthlyTonnagePoint, 'month'>; label: string; color: string }[] = [
  { key: 'cobre', label: 'Cobre', color: '#1A7A4C' },
  { key: 'oro', label: 'Oro', color: '#2a8a87' },
  { key: 'hierro', label: 'Hierro', color: '#EAB308' },
  { key: 'zinc', label: 'Zinc', color: '#3d6fa8' },
  { key: 'plata', label: 'Plata', color: '#b5aa9d' },
]

interface TonnageChartProps {
  data: MonthlyTonnagePoint[]
}

export default function TonnageChart({ data }: TonnageChartProps) {
  const { axis, grid } = useChartTheme()

  return (
    <Box h="320px">
      <ResponsiveContainer width="100%" height="100%">
        <AreaChart data={data}>
          <defs>
            {minerals.map((m) => (
              <linearGradient key={m.key} id={`grad-${m.key}`} x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stopColor={m.color} stopOpacity={0.4} />
                <stop offset="100%" stopColor={m.color} stopOpacity={0.05} />
              </linearGradient>
            ))}
          </defs>
          <CartesianGrid stroke={grid.stroke} strokeDasharray={grid.strokeDasharray} />
          <XAxis dataKey="month" stroke={axis.stroke} tick={axis.tick} />
          <YAxis stroke={axis.stroke} tick={axis.tick} tickFormatter={(v: number) => `${(v / 1000).toFixed(0)}k`} />
          <Tooltip content={<CustomTooltip formatter={(v) => `${v.toLocaleString()} TM`} />} />
          <Legend
            wrapperStyle={{ fontSize: 11, fontFamily: "'Instrument Sans', sans-serif" }}
          />
          {minerals.map((m) => (
            <Area
              key={m.key}
              type="monotone"
              dataKey={m.key}
              name={m.label}
              stackId="1"
              stroke={m.color}
              fill={`url(#grad-${m.key})`}
              strokeWidth={1.5}
            />
          ))}
        </AreaChart>
      </ResponsiveContainer>
    </Box>
  )
}
